import { useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "srm_theme";
export const applyStoredTheme = () => document.documentElement.classList.toggle("light", localStorage.getItem(KEY) === "light");

export const ThemeToggle = () => {
  const [light, setLight] = useState(() => localStorage.getItem(KEY) === "light");
  const toggle = () => {
    const next = !light;
    localStorage.setItem(KEY, next ? "light" : "dark");
    document.documentElement.classList.toggle("light", next);
    setLight(next);
  };
  return (
    <button onClick={toggle} title={light ? "Switch to black background" : "Switch to white background"} data-testid="theme-toggle-button"
      className="flex h-8 items-center gap-1.5 rounded-full border border-slate-700 px-2.5 text-xs text-slate-400 transition-colors hover:text-amber-400">
      {light ? <Moon className="h-3.5 w-3.5" /> : <Sun className="h-3.5 w-3.5" />}
      {light ? "Black" : "White"}
    </button>
  );
};
